import { buttonSizes, buttonVariants } from '@/components/shared';
import { Button } from './Button';
import register from './register';

register(Button, {
	variants: buttonVariants,
	sizes: buttonSizes,
	defaultVariant: 'primary',
	defaultSize: 'md',
});
